import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CommercialRole } from "../../pageInside/Rolle";
import { elakayAutoText } from "../dataElakay";
// Country / ZIP / State / City: the shared Elakay address location fields
// (Country -> State -> City, or Country -> ZIP -> auto-fill). The legacy
// loadCountries / allZipCodes / setAllZipCodes props are still accepted
// but no longer needed (the whole country file is not downloaded anymore).
import AddressLocationSelector from "../addressLocation/AddressLocationSelector";
import { toLocationValue, fromLocationValue } from "../addressLocation/addressLocationData";

const FormAddress = (props) => {
    const {
        clickSubmit,
        values,
        setValues,
        infoSource,
        phoneUser,
        editBtnFunction,
        buttonActive = true,
        btnCancel = true,
        btnEdit = true,
        BorderActive = true
    } = props;

    const {
        firstName,
        lastName,
        shopName,
        tel,
        Address1,
        Address2,
        city,
        State,
        postalCode,
        country,
        error,
    } = values;

    // Styles CSS Premium
    const premiumStyles = `
/* ===== ANIMATIONS PREMIUM ===== */
@keyframes formEnter {
    from {
        opacity: 0;
        transform: translateY(30px) scale(0.97);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes fieldSlideIn {
    from {
        opacity: 0;
        transform: translateX(-20px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes shimmerGlow {
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
}

@keyframes floatBadge {
    0%, 100% {
        transform: translateY(0) scale(1);
    }
    50% {
        transform: translateY(-3px) scale(1.02);
    }
}

@keyframes pulseButton {
    0%, 100% {
        box-shadow: 0 4px 16px rgba(0, 164, 216, 0.3);
    }
    50% {
        box-shadow: 0 6px 24px rgba(0, 164, 216, 0.5);
    }
}

/* Page animation */
.form-address-premium {
    animation: formEnter 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

/* Row stagger */
.row {
    animation: fieldSlideIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.row:nth-child(1) { animation-delay: 0.05s; }
.row:nth-child(2) { animation-delay: 0.1s; }
.row:nth-child(3) { animation-delay: 0.15s; }
.row:nth-child(4) { animation-delay: 0.2s; }
.row:nth-child(5) { animation-delay: 0.25s; }
.row:nth-child(6) { animation-delay: 0.3s; }

/* ===== CONTAINER PREMIUM ===== */

/* Container avec border */
.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"] {
    border-radius: 24px !important;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.95) 0%, 
            rgba(248, 250, 252, 0.98) 100%
        ) !important;
    backdrop-filter: blur(20px);
    box-shadow: 
        0 20px 60px rgba(0, 115, 153, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.8),
        inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
    border: 1px solid rgba(226, 232, 240, 0.8) !important;
    overflow: hidden;
    position: relative;
}

/* Shimmer effect */
.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"]::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
        circle at center,
        rgba(0, 164, 216, 0.06) 0%,
        transparent 60%
    );
    animation: shimmerGlow 10s linear infinite;
    pointer-events: none;
    z-index: 0;
}

.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"] > * {
    position: relative;
    z-index: 1;
}

/* ===== HEADER PREMIUM ===== */

.row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: Gainsboro"] {
    background: 
        linear-gradient(135deg, 
            rgba(0, 115, 153, 0.1) 0%, 
            rgba(0, 164, 216, 0.08) 100%
        ),
        linear-gradient(180deg, 
            rgba(255, 255, 255, 0.9) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        ) !important;
    border-bottom: 2px solid transparent !important;
    border-image: linear-gradient(90deg, 
        transparent 0%, 
        rgba(0, 164, 216, 0.4) 50%,
        transparent 100%
    ) 1 !important;
    padding: 2rem 1rem !important;
    position: relative;
}

.row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: Gainsboro"] h3 {
    background: linear-gradient(135deg, 
        #006b8a 0%, 
        #007399 25%,
        #00a4d8 50%,
        #007399 75%,
        #006b8a 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 800;
    margin: 0;
    letter-spacing: -0.02em;
    animation: shimmerGlow 3s linear infinite;
}

/* ===== FORM STYLING PREMIUM ===== */

/* Form container */
.form-address-premium.m-4 {
    padding: 2rem !important;
}

/* Form group */
.form-address-premium .form-group {
    margin-bottom: 1.75rem;
    position: relative;
}

/* Labels premium */
.form-address-premium .text-muted {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    color: #1e293b !important;
    margin-bottom: 0.75rem;
    font-size: 0.9375rem;
    letter-spacing: -0.01em;
}

.form-address-premium .text-muted::before {
    content: '';
    width: 3px;
    height: 16px;
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    border-radius: 2px;
}

/* Inputs premium */
.form-address-premium .form-control {
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        );
    backdrop-filter: blur(10px);
    border: 2px solid rgba(226, 232, 240, 0.8);
    border-radius: 14px;
    // padding: 0.875rem 1.25rem;
    font-size: 1rem;
    color: #1e293b;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 
        0 2px 8px rgba(0, 115, 153, 0.06),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.form-address-premium .form-control::placeholder {
    color: #94a3b8;
    font-weight: 400;
}

.form-address-premium .form-control:focus {
    outline: none;
    border-color: rgba(0, 164, 216, 0.6);
    background: #ffffff;
    box-shadow: 
        0 0 0 4px rgba(0, 164, 216, 0.1),
        0 4px 16px rgba(0, 115, 153, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 1);
    transform: translateY(-2px);
}

/* Select dropdown premium */
.form-address-premium select.form-control {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23007399' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    padding-right: 3rem;
    cursor: pointer;
}

.form-address-premium select.form-control:hover {
    border-color: rgba(0, 164, 216, 0.4);
}

/* ===== ERROR ALERT PREMIUM ===== */

.alert-danger {
    background: linear-gradient(135deg, 
        rgba(254, 202, 202, 0.95) 0%, 
        rgba(252, 165, 165, 0.9) 100%
    );
    backdrop-filter: blur(10px);
    border: 2px solid rgba(239, 68, 68, 0.3);
    border-radius: 14px;
    padding: 1rem 1.25rem;
    color: #991b1b;
    font-weight: 600;
    box-shadow: 
        0 4px 12px rgba(239, 68, 68, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
    margin-bottom: 1.5rem;
    animation: fieldSlideIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

/* ===== BUTTONS PREMIUM ===== */

/* Container buttons */
.form-address-premium .bg.clearfix {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-top: 2rem !important;
    padding: 0 !important;
}

/* Button base style */
.form-address-premium .btn {
    padding: 0.875rem 2rem !important;
    border-radius: 14px !important;
    font-weight: 700;
    font-size: 1rem;
    letter-spacing: -0.01em;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    overflow: hidden;
    border: none;
    margin: 0 !important;
}

/* Cancel button */
.form-address-premium .btn.float-left {
    background: 
        linear-gradient(135deg, 
            rgba(241, 245, 249, 0.98) 0%, 
            rgba(226, 232, 240, 0.95) 100%
        );
    color: #475569;
    box-shadow: 
        0 4px 12px rgba(71, 85, 105, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
}

.form-address-premium .btn.float-left::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(148, 163, 184, 0.2) 0%, 
        transparent 100%
    );
    opacity: 0;
    transition: opacity 0.4s ease;
}

.form-address-premium .btn.float-left:hover {
    background: 
        linear-gradient(135deg, 
            rgba(226, 232, 240, 0.98) 0%, 
            rgba(203, 213, 225, 0.95) 100%
        );
    transform: translateY(-3px);
    box-shadow: 
        0 8px 24px rgba(71, 85, 105, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.9);
    color: #334155;
}

.form-address-premium .btn.float-left:hover::before {
    opacity: 1;
}

/* Save button */
.form-address-premium .btn.float-right {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    color: #ffffff;
    box-shadow: 
        0 4px 16px rgba(0, 164, 216, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
    animation: pulseButton 2s ease-in-out infinite;
}

.form-address-premium .btn.float-right::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.3) 0%, 
        transparent 100%
    );
    opacity: 0;
    transition: opacity 0.4s ease;
}

.form-address-premium .btn.float-right:hover {
    background: linear-gradient(135deg, #006b8a 0%, #007399 100%);
    transform: translateY(-4px) scale(1.02);
    box-shadow: 
        0 12px 32px rgba(0, 164, 216, 0.5),
        0 0 40px rgba(0, 164, 216, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.form-address-premium .btn.float-right:hover::before {
    opacity: 1;
}

/* Disabled button */
.form-address-premium .btn.disabled {
    background: linear-gradient(135deg, 
        rgba(203, 213, 225, 0.5) 0%, 
        rgba(148, 163, 184, 0.5) 100%
    );
    color: #94a3b8;
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
    animation: none;
}

.form-address-premium .btn.disabled:hover {
    transform: none;
    box-shadow: none;
}

/* ===== RESPONSIVE ===== */

@media (max-width: 768px) {
    .row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"] {
        border-radius: 20px !important;
    }

    .row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: Gainsboro"] {
        padding: 1.5rem 1rem !important;
    }

    .form-address-premium.m-4 {
        padding: 1.5rem !important;
    }

    .form-address-premium .form-group {
        margin-bottom: 1.5rem;
    }

    .form-address-premium .form-control {
        // padding: 0.75rem 1rem;
        font-size: 0.9375rem;
        border-radius: 12px;
    }

    .form-address-premium .btn {
        padding: 0.75rem 1.5rem !important;
        font-size: 0.9375rem;
        border-radius: 12px !important;
    }

    .form-address-premium .bg.clearfix {
        flex-direction: column-reverse;
        gap: 0.75rem;
    }

    .form-address-premium .btn.float-left,
    .form-address-premium .btn.float-right {
        width: 100%;
        float: none !important;
    }
}

/* ===== REDUCED MOTION ===== */

@media (prefers-reduced-motion: reduce) {
    .form-address-premium,
    .row,
    .form-address-premium .form-control,
    .form-address-premium .btn,
    .row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: Gainsboro"] h3 {
        animation: none !important;
        transition: none !important;
    }
}

/* ===== ADDITIONAL ENHANCEMENTS ===== */

/* Input focus glow */
.form-address-premium .form-control:focus {
    position: relative;
}

.form-address-premium .form-control:focus::after {
    content: '';
    position: absolute;
    inset: -2px;
    border-radius: 14px;
    border: 2px solid rgba(0, 164, 216, 0.3);
    pointer-events: none;
}

/* Row spacing */
.form-address-premium .row {
    margin-bottom: 0.5rem;
}

/* Col spacing */
.form-address-premium .col,
.form-address-premium .col-md-6 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
`;

    const [geoRequirements, setGeoRequirements] = useState({ postalRequired: true, stateRequired: true });

    const handleChange = name => event => {
        setValues({ ...values, [name]: event.target.value, error: false });
    };
    // Only the location fields are written; name, street, phone... are kept.
    const handleLocationChange = (location) =>
        setValues((prev) => ({ ...fromLocationValue(prev, location), error: false }));

    const showError = () => (
        <div
            className="alert alert-danger"
            style={{ display: error ? "" : "none" }}
        >
            {error}
        </div>
    );

    const filled = (value) => String(value ?? "").trim() !== "";
    const AdressTrue = filled(firstName) && filled(lastName) && filled(tel) && filled(city) && filled(country) && filled(Address1)
        && (!geoRequirements.postalRequired || filled(postalCode))
        && (!geoRequirements.stateRequired || filled(State));

    const address1Ref = useRef(null);
    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const telRef = useRef(null);

    const scrollToFirstMissingField = () => {
        const byId = (id) => ({ current: document.getElementById(id) });
        const fields = [
            [country, byId("form-address-country")],
            [Address1, address1Ref],
            [city, byId("form-address-city")],
            [geoRequirements.stateRequired ? State : "-", byId("form-address-state")],
            [geoRequirements.postalRequired ? postalCode : "-", byId("form-address-zip")],
            [firstName, firstNameRef],
            [lastName, lastNameRef],
            [tel, telRef],
        ];
        const missing = fields.find(([value]) => !value);
        if (missing && missing[1].current) {
            missing[1].current.scrollIntoView({ behavior: "smooth", block: "center" });
            missing[1].current.focus?.();
        }
    };

    // Fonction générique pour rendre un champ input
    const renderInput = (id, value, label, placeholder, onChange, type = "text", inputRef = null, hint = null) => (
        <div className="form-group">
            <label className="text-muted">{label}</label>
            <input
                ref={inputRef}
                id={id}
                onChange={onChange}
                type={type}
                placeholder={placeholder}
                value={value ?? ""}
                className="form-control"
            />
            {hint && <small className="form-text text-muted">{hint}</small>}
        </div>
    );

    // Fonction générique pour rendre un champ select
    const renderSelect = (id, value, label, options, onChange, selectRef = null, hint = null) => (
        <div className="form-group">
            <label className="text-muted">{label}</label>
            <select ref={selectRef} id={id} onChange={onChange} className="form-control" value={value ?? ""}>
                <option>{infoSource.laguangeElakay("label", infoSource.languageAPI).pleaseSelect}</option>
                {options?.map((option, i) => (
                    <option key={i} value={option.code || option.International}>
                        {option.name || option.International}
                    </option>
                ))}
            </select>
            {hint && <small className="form-text text-muted">{hint}</small>}
        </div>
    );

    const formWithoutBorder = () => {
        return (
            <>
                <style>{premiumStyles}</style>
                {showError()}

                <form className="m-4 form-address-premium" onSubmit={clickSubmit}>
                    {/* Country, ZIP / postal code, State, City (shared selector) */}
                    <div className="row">
                        <AddressLocationSelector
                            idPrefix="form-address"
                            value={toLocationValue(values)}
                            onChange={handleLocationChange}
                            onRequirementsChange={setGeoRequirements}
                            emptyCountryLabel={infoSource.laguangeElakay("label", infoSource.languageAPI).pleaseSelect}
                            labels={{ country: infoSource.laguangeElakay("label", infoSource.languageAPI).country }}
                            classNames={{ field: "col-md-6 form-group", label: "text-muted", input: "form-control", hint: "form-text text-muted", status: "col-12" }}
                            hints={{
                                country: elakayAutoText("h_formaddress_hint_country", "The country this address is in"),
                                postalCode: elakayAutoText("h_addrloc_hint_postal", "Type it to fill in the state and the city, or choose them below."),
                            }}
                        />
                    </div>

                    <div className="row">
                        <div className="col">
                            {renderInput(
                                "address-line1",
                                Address1,
                                infoSource.laguangeElakay("label", infoSource.languageAPI).Address1,
                                infoSource.laguangeElakay("label", infoSource.languageAPI).Address1,
                                handleChange("Address1"),
                                "text",
                                address1Ref,
                                elakayAutoText("h_formaddress_hint_address1", "Street number and name (e.g. 123 Main St)")
                            )}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            {renderInput(
                                "address-line2",
                                Address2,
                                elakayAutoText("h_addrloc_address2", "Apartment, suite, unit (optional)"),
                                "",
                                handleChange("Address2")
                            )}
                        </div>
                    </div>

                    {/* Remaining Form Fields */}
                    <div className="row">
                        <div className="col-md-6">
                            {renderInput(
                                "first-name",
                                firstName,
                                infoSource.laguangeElakay("label", infoSource.languageAPI).fisrtName,
                                infoSource.laguangeElakay("label", infoSource.languageAPI).fisrtName,
                                handleChange("firstName"),
                                "text",
                                firstNameRef,
                                elakayAutoText("h_formaddress_hint_firstname", "First name of the person at this address")
                            )}
                        </div>
                        <div className="col-md-6">
                            {renderInput(
                                "last-name",
                                lastName,
                                infoSource.laguangeElakay("label", infoSource.languageAPI).lastName,
                                infoSource.laguangeElakay("label", infoSource.languageAPI).lastName,
                                handleChange("lastName"),
                                "text",
                                lastNameRef,
                                elakayAutoText("h_formaddress_hint_lastname", "Last name of the person at this address")
                            )}
                        </div>
                    </div>

                    {CommercialRole() && (
                        <div className="form-group">
                            {renderInput(
                                "shop-name",
                                shopName,
                                infoSource.laguangeElakay("label", infoSource.languageAPI).shopName,
                                infoSource.laguangeElakay("label", infoSource.languageAPI).shopName,
                                handleChange("shopName")
                            )}
                        </div>
                    )}

                    <div className="form-group">
                        {renderSelect(
                            "tel",
                            tel,
                            infoSource.laguangeElakay("label", infoSource.languageAPI).phone,
                            phoneUser,
                            handleChange("tel"),
                            telRef,
                            elakayAutoText("h_formaddress_hint_phone", "A phone number where you can be reached about this address")
                        )}
                    </div>

                    {/* Buttons */}
                    {buttonActive && (
                        <div className="row justify-content-center">
                            <div className="bg clearfix">
                                {btnCancel && (
                                    <Link
                                        onClick={() => editBtnFunction()}
                                        className="btn btn-info float-left"
                                    >
                                        {infoSource.laguangeElakay("Button", infoSource.languageAPI).cancel}
                                    </Link>
                                )}
                                {btnEdit && (AdressTrue ? (
                                    <button className="btn btn-info float-right">
                                        {infoSource.laguangeElakay("Button", infoSource.languageAPI).save}
                                    </button>
                                ) : (
                                    <button type="button" onClick={scrollToFirstMissingField} className="btn btn-info float-right disabled">
                                        {infoSource.laguangeElakay("Button", infoSource.languageAPI).save}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </form>
            </>
        );
    };

    const formAdd = () => {
        return (
            <>
                <style>{premiumStyles}</style>
                <div className="row mt-4 mb-4 justify-content-center">
                    <div className="col col-12 col-md-10 col-lg-8 p-0" style={{ border: "1px solid Gainsboro" }}>
                        <div className="col col-12" style={{ textAlign: "center", backgroundColor: "Gainsboro" }}>
                            <h3>{infoSource.laguangeElakay('title', infoSource.languageAPI).yourAddress}</h3>
                        </div>
                        {/* **************************** */}
                        <div className="contenair">
                            {formWithoutBorder()}
                        </div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            {BorderActive ? formAdd() : formWithoutBorder()}
        </>
    );
};

export default FormAddress;
